export const SESSIONS = [
  { key: "asian", label: "Asian", hours: "00–09 UTC", start: 0, end: 9, color: "#8B5CF6", badge: "bg-purple-950/60 text-purple-300 border-purple-800/50" },
  { key: "london", label: "London", hours: "07–16 UTC", start: 7, end: 16, color: "#F59E0B", badge: "bg-amber-950/60 text-amber-300 border-amber-800/50" },
  { key: "new_york", label: "New York", hours: "12–21 UTC", start: 12, end: 21, color: "#06B6D4", badge: "bg-cyan-950/60 text-cyan-300 border-cyan-800/50" },
];

export const sessionByKey = Object.fromEntries(SESSIONS.map((s) => [s.key, s]));

export const ACCOUNT_TYPES = {
  live: { label: "Live", badge: "bg-emerald-950/60 text-emerald-400 border-emerald-800/50" },
  demo: { label: "Demo", badge: "bg-slate-800/80 text-slate-300 border-slate-700/50" },
  prop: { label: "Prop Firm", badge: "bg-amber-950/60 text-amber-300 border-amber-800/50" },
};

export function activeSessions(date = new Date()) {
  const h = date.getUTCHours();
  return SESSIONS.filter((s) => h >= s.start && h < s.end).map((s) => s.key);
}

export function fmtPnl(v) {
  const n = Number(v || 0);
  const s = Math.abs(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${n > 0 ? "+" : n < 0 ? "-" : ""}$${s}`;
}

export const pnlClass = (v) => (v > 0 ? "text-emerald-400" : v < 0 ? "text-red-400" : "text-slate-400");

export function fmtUtc(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return `${d.toISOString().slice(0, 10)} ${d.toISOString().slice(11, 16)}`;
}
